import type { GQL_ID } from '@@partner:types:graphql'
import type { TextMaterial } from '@@partner:types:app'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_TEXT_MATERIAL_FIELDS } from '../textMaterialShortcut'

export interface SingleTextMaterialQuery {
  singleTextMaterial: TextMaterial
}
export interface SingleTextMaterialQueryVariables {
  id?: GQL_ID
}

export const GQL_QUERY_SINGLE_TEXT_MATERIAL = gql`
  query singleTextMaterial (
    $id: ID!
  ) {
    singleTextMaterial(id: $id) {
      ${SHORTCUT_TEXT_MATERIAL_FIELDS}
    }
  }
`

export const useFetchSingleTextMaterial = (
  variables: SingleTextMaterialQueryVariables
) => {
  return useQuery<SingleTextMaterialQuery, SingleTextMaterialQueryVariables>(
    GQL_QUERY_SINGLE_TEXT_MATERIAL,
    {
      variables,
      skip: !variables.id
    }
  )
}
